<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/_main'
import PageHeader from '@components/page-header'

import {deviceApi} from '@router/apiFiles/deviceApi'

/**
 * Order Detail
 */
export default {
  page: {
    title: 'Device',
    meta: [{name: 'description', content: appConfig.description}],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      items: [
        {
          text: 'OnBoard',
          href: '/',
        },
        {
          text: 'Devices',
          href: '/',
        },
        {
          text: 'Device',
          active: true,
        },
      ],
      isBusy: true,
      device: {},
      lastMessages: [],
      show: false,
      planActive: null,
      confirmation: false,
      showPlanSelection: false,
      showPlanConfirmation: false,
      selectedPlanType: null,
      activatingPlan: false,
      groups: [],
      dbcs: [],
      showTableTelemetry: false,
      brands: [],
      models: [],

      telemetry: [
        {parameter: 'btf', type: 'boolean', unity: '-', description: 'Low battery indicator (from vehicle)'},
        {parameter: 'ocs', type: 'boolean', unity: '-', description: 'Idle vehicle indicator'},
        {parameter: 'svu', type: 'boolean', unity: '-', description: 'Severe vehicle use indicator'},
        {parameter: 'tpa', type: 'number', unity: 'ºC', description: 'Engine coolant temperature'},
        {parameter: 'toh', type: 'number', unity: 'ºC', description: 'Hydraulic oil temperature'},
        {parameter: 'tpt', type: 'number', unity: 'ºC', description: 'Transmission oil temperature'},

        {parameter: 'cbc', type: 'number', unity: 'L/h', description: 'Fuel consumption (moving average)'},
        {parameter: 'cbt', type: 'number', unity: '%', description: 'Fuel level'},
        {parameter: 'hor', type: 'number', unity: 'H', description: 'Engine hour counter'},
        {parameter: 'hrb', type: 'number', unity: 'H', description: 'Additional hour meter (key post/others)'},
        {parameter: 'hod', type: 'number', unity: 'Km', description: 'Vehicle odometer'},
        {parameter: 'erc', type: 'bolean', unity: '-', description: 'Day fault code counter'},
        {parameter: 'err', type: 'bolean', unity: '-', description: 'Current fault code'},
        {parameter: 'erd', type: 'number', unity: '-', description: 'Penultimate fault code'},
        {parameter: 'pcb', type: 'number', unity: 'kPa', description: 'Fuel Pressure'},
        {parameter: 'pom', type: 'number', unity: 'kPa', description: 'Engine oil pressure'},
        {parameter: 'ptb', type: 'number', unity: 'kPa', description: 'Turbo pressure'},
        {parameter: 'tbt', type: 'number', unity: 'V', description: 'Battery Voltage'},
        {parameter: 'acl', type: 'number', unity: 'G', description: 'Longitudinal acceleration of the vehicle'},

        {parameter: 'cgm', type: 'number', unity: '%', description: 'Engine load (moving average)'},
        {parameter: 'rpm', type: 'number', unity: 'RPM', description: 'Engine speed (moving average)'},
        {parameter: 'mtt', type: 'number', unity: 'ºC', description: 'Maximum transmission temperature (daily)'},
        {parameter: 'tuo', type: 'number', unity: 'min', description: 'Total idle usage time (daily)'},
        {parameter: 'tus', type: 'number', unity: 'min', description: 'Total time of severe use (daily)'},
        {parameter: 'pan', type: 'boolean', unity: '-', description: 'Panic indicator (when installed)'},
        {parameter: 'mta', type: 'number', unity: 'ºC', description: 'Maximum engine temperature (daily)'},
        {parameter: 'mcc', type: 'number', unity: 'L/h', description: 'Maximum fuel consumption (daily)'},
        {parameter: 'mov', type: 'bolean', unity: '-', description: 'Indicates that the vehicle is on the way'},
        {parameter: 'mth', type: 'number', unity: 'ºC', description: 'Maximum hydraulic temperature (daily)'},

        {parameter: 'fmi', type: 'number', unity: '-', description: 'Failure mode (associated with SPN)'},
        {parameter: 'tam', type: 'number', unity: '-', description: 'Engine intake air temperature'},
        {parameter: 'rfi', type: 'number', unity: '-', description: 'RFID reading'},
        {parameter: 'in1', type: 'boolean', unity: '-', description: 'Entry 01'},
        {parameter: 'in2', type: 'boolean', unity: '-', description: 'Entry 02'},
        {parameter: 'bus', type: 'number', unity: 'º', description: 'Compass (0º to 359º)'},
      ]
    }
  },
  props: {
    number: {
      type: String,
      default: null
    }
  },
  computed: {
    orderIsValid() {
    },
    isEsnFormat() {
      // Verifica se o modemIdentifier está no formato ESN: "0-0000000"
      if (!this.device.modemIdentifier) return false;
      const esnPattern = /^\d-\d{7}$/;
      return esnPattern.test(this.device.modemIdentifier);
    },
    shouldShowPlanOptions() {
      // Mostra opções de plano se:
      // 1. Não tem plano ativo (planActive === false)
      // 2. supplierPlanName está vazio ou nulo
      // 3. modemIdentifier está no formato ESN
      return this.planActive === false && 
             (!this.device.supplierPlanName || this.device.supplierPlanName.trim() === '') && 
             this.isEsnFormat;
    }
  },
  mounted() {
    this.setInitialData()
  },
  methods: {
    
    setInitialData(){
      this.getDeviceGroup()
      this.searchAllConfigurationBrand();
      this.searchConfigurationModel();
      this.getDeviceComplete()
      this.getPlanActivationStatus()
      this.getDBCs()
    },
    getDeviceComplete() {
      deviceApi.getDeviceComplete({id: this.$route.params.id})
          .then(data => {
            this.device = data;
            this.isBusy = false;
          });
    },
    getPlanActivationStatus() {
      deviceApi.getPlanActivationStatus({deviceId: this.$route.params.id})
          .then(activationData => {
            if (activationData != null) this.planActive = activationData.active;
          });
    },
    getDeviceGroup() {
      deviceApi.searchDeviceGroups({search: '', customerId: '', page: 1, perPage: 100})
          .then(data => {
            this.groups = data.data;
            this.isBusy = false;
          });
    },
    getDBCs() {
      deviceApi.searchDBCs({search: '', page: 1, perPage: 100})
          .then(data => {
            this.dbcs = data.data;
            this.isBusy = false;
          });
    },
    handleSelectBrand(event) {
      this.searchConfigurationModel();
    },
    handleSelectModel(event) {
      this.device.installedModelName = event.target.options[event.target.selectedIndex].text
    },
    searchAllConfigurationBrand() {
      deviceApi.searchAllConfigurationBrand()
          .then(data => {
            this.brands = data.data;
            this.isBusy = false;
          });
    },
    searchConfigurationModel() {
      deviceApi.searchConfigurationModels({brandId: this.device.installConfigurationBrandId})
          .then(data => {
            this.models = data.data;
            this.isBusy = false;
          });
    },

    update() {
      var self = this;
      self.isBusy = true;
      self.show = false;
      if (this.device.hourmeterOffset) this.device.hourmeterOffset = this.device.hourmeterOffset.toString().replace(",", ".")
      deviceApi.updateDevice({id: self.$route.params.id, ...self.device})
          .then(function (data) {
            self.isBusy = false;
          });
    },
    openPlanSelection() {
      this.showPlanSelection = true;
      this.selectedPlanType = null;
    },
    selectPlan(planType) {
      this.selectedPlanType = planType;
    },
    getPlanName(planType) {
      const planNames = {
        'standard': 'Standard Plan',
        'test': 'Test Plan',
        'safelink': 'Safe Link Plan'
      };
      return planNames[planType] || planType;
    },
    openConfirmationModal() {
      if (!this.selectedPlanType) {
        this.$bvToast.toast('Please select a plan before continuing.', {
          title: 'Warning',
          variant: 'warning',
          solid: true
        });
        return;
      }
      this.showPlanConfirmation = true;
    },
    async confirmPlanActivation() {
      this.showPlanConfirmation = false;
      this.activatingPlan = true;
      
      try {
        let response;
        const deviceId = this.$route.params.id;

        switch(this.selectedPlanType) {
          case 'standard':
            response = await deviceApi.activateDevicePlan({ deviceId });
            break;
          case 'test':
            response = await deviceApi.fetchActivateTestPlan({ deviceId });
            break;
          case 'safelink':
            response = await deviceApi.fetchActivateSafeLinkPlan({ deviceId });
            break;
        }

        this.$bvToast.toast('Plan activated successfully!', {
          title: 'Success',
          variant: 'success',
          solid: true
        });

        this.showPlanSelection = false;
        this.selectedPlanType = null;
        await this.setInitialData();

      } catch (error) {
        console.error('Error activating plan:', error);
        this.$bvToast.toast('Error activating the plan. Please try again.', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      } finally {
        this.activatingPlan = false;
      }
    },
    activateDevicePlan() {
      var self = this;
      self.confirmation = false;
      self.isBusy = true;
      deviceApi.activateDevicePlan({deviceId: self.$route.params.id})
          .finally(function () {
            self.isBusy = false;
            self.setInitialData();
          });
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <b-overlay :show="isBusy">
      <div class="row">

        <div class="col-lg-4">
          <div class="card">
            <div class="card-body">
              <h4 class="header-title mb-3">Device <a href="javascript: void(0);" @click="show = true"
                                                      class="btn btn-primary btn-sm float-right">Edit<i
                  class="uil uil-edit ml-1"></i></a>
              </h4>
              <div class="row">
                <div class="col-lg-6">
                  <div class="mb-4">
                    <h5 class="mt-0">Modem Id:</h5>
                    <p>{{ device.modemIdentifier }}</p>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="mb-4">
                    <h5 class="mt-0">Chassis:</h5>
                    <p>{{ device.chassis }}</p>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="mb-4">
                    <h5 class="mt-0">Model Installed</h5>
                    <p>{{ device.installedModelName }}</p>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="mb-4">
                    <h5 class="mt-0">Hourmeter Offset:</h5>
                    <p>{{ device.hourmeterOffset }}</p>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-6">
                  <div class="mb-4">
                    <h5 class="mt-0">Odometer Offset:</h5>
                    <p>{{ device.odometerOffset }}</p>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <div class="mb-4">
                    <h5>Status</h5>
                    <div class="mb-2" v-show="device.supplierPlanName">
                      <span class="font-size-16 font-weight-bolder">Plan: </span> <span
                        class="font-size-14">{{ device.supplierPlanName }}</span>
                    </div>
                    <div>
											<span v-if="planActive == null" role="status"
                            class="spinner-border text-primary"></span>
                      <span v-if="planActive == true"
                            class="badge badge-success badge-pill">Active</span>
                      <span v-if="planActive == false" class="badge badge-info badge-pill">Not
												activated</span>
                      
                      <!-- Botão para seleção de planos (ESN format) -->
                      <a v-if="shouldShowPlanOptions" href="javascript: void(0);"
                         @click="openPlanSelection" class="btn btn-primary btn-xs ml-1">
                        <i class="uil uil-plus-circle mr-1"></i>Choose Plan
                      </a>
                      
                      <!-- Botão padrão para ativação direta (não-ESN format) -->
                      <a v-else-if="planActive == false && !shouldShowPlanOptions" href="javascript: void(0);"
                         @click="confirmation = true" class="btn btn-danger btn-xs ml-1">Activate
                        Plan<i class="uil uil-dollar-alt ml-1"></i></a>
                    </div>
                  </div>
                </div>
              </div>

              <div class="track-order-list">
                <ul class="list-unstyled">
                  <li v-bind:class="device.hasConnected ? 'completed' : ''">
                    <span v-if="!device.hasConnected" class="active-dot dot"></span>
                    <h5 class="mt-0 mb-1">Created</h5>
                    <p class="text-muted">{{ device.dateCreated }}</p>
                  </li>
                  <li>
                    <span v-if="device.hasConnected" class="active-dot dot"></span>
                    <h5 class="mt-0 mb-1">Connected</h5>
                    <p class="text-muted">{{ device.dateConnected }} <small class="text-muted">{{
                        device.timeConnected
                      }}</small></p>
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>

        <div class="col-lg-8">
          <div class="card">
            <div class="card-body">
              <h4 class="header-title mb-3">Last messages <a v-bind:href="'/telemetry/' + $route.params.id"
                                                             class="btn btn-primary btn-sm float-right">See more<i
                  class="uil uil-search ml-1"></i></a></h4>

              <div class="table-responsive">
                <br/>

                <table class="table table-bordered table-centered mb-0">
                  <thead class="thead-light">
                  <tr>
                    <th>Id</th>
                    <th>Date/Time</th>
                    <th>Location</th>
                    <th>Content</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in device.lastMessages" :key="item.id">
                    <td scope="row">{{ item.id }}</td>
                    <td>{{ item.date }}</td>
                    <td><a target="_blank" class="btn btn-primary btn-sm"
                           v-if="item.lat != null && item.lat != null"
                           v-bind:href="'https://www.google.com/maps/search/?api=1&query=' + item.lat + '%2C' + item.lng"><i
                        class="uil uil-map-marker"></i></a></td>
                    <td>{{ item.data }} <span
                        v-if="(item.lat != null && item.lat != null) && item.data == null">lat:{{
                        item.lat
                      }},
													lng:{{ item.lng }}</span></td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div role="tablist" class="custom-accordionwitharrow">
                <b-card no-body class="mb-1 border shadow-none">
                  <b-card-header header-tag="header" role="tab">
                    <a v-b-toggle.accordion-1 @click="showTableTelemetry = !showTableTelemetry"
                       href="javascript: void(0);"
                       class="text-black d-flex justify-content-between align-items-center">
                      <h5 class="h5 m-0 font-size-16">Telemetry Captions</h5>
                      <feather v-if="!showTableTelemetry" type="chevron-down"></feather>
                      <feather v-else type="chevron-up"></feather>
                    </a>
                  </b-card-header>
                  <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <div class="table-responsive">
                        <table class="table table-bordered table-centered mb-0">
                          <thead class="thead-light">
                          <tr>
                            <th>Parameter</th>
                            <th>Type</th>
                            <th>Unit</th>
                            <th>Description</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="item in telemetry" :key="item.parameter">
                            <td scope="row"><strong>{{ item.parameter }}</strong></td>
                            <td>{{ item.type }}</td>
                            <td>{{ item.unity }}</td>
                            <td>{{ item.description }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
          </div>
        </div>


      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-body">
              <h4 class="header-title mb-3">Note</h4>
              <textarea class="form-control bg-soft-warning" rows="6" v-model="device.note"></textarea>
            </div>
          </div>
        </div>
      </div>


      <div>
        <b-modal v-model="show" title="Edit device" title-class="font-18">
          <form class="form-horizontal">
            <b-row class="mb-3">
              <b-col sm="3">
                <label>Modem Id</label>
              </b-col>
              <b-col sm="9">
                <b-form-input v-model="device.modemIdentifier" readonly="readonly"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3">
                <label>Chassis</label>
              </b-col>
              <b-col sm="9">
                <b-form-input v-model="device.chassis"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3">
                <label>Hourmeter Offset</label>
              </b-col>
              <b-col sm="9">
                <b-form-input v-model="device.hourmeterOffset"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3">
                <label>Odometer Offset</label>
              </b-col>
              <b-col sm="9">
                <b-form-input v-model="device.odometerOffset"></b-form-input>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3">
                <label>Group</label>
              </b-col>
              <b-col sm="9">
                <select class="form-control" v-model="device.groupId" style="max-width:100%">
                  <option :value="null"></option>
                  <option v-for="group of groups" v-bind:key="group.id" v-bind:value="group.id">
                    {{ group.name }}
                  </option>
                </select>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3">
                <label>DBC</label>
              </b-col>
              <b-col sm="9">
                <select class="form-control" v-model="device.dbcId" style="max-width:100%">
                  <option :value="null"></option>
                  <option v-for="dbc of dbcs" v-bind:key="dbc.id" v-bind:value="dbc.id">
                    {{ dbc.name }}
                  </option>
                </select>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3">
                <label>Brand</label>
              </b-col>
              <b-col sm="9">
                <select @change="handleSelectBrand" class="form-control" v-model="device.installConfigurationBrandId"
                        style="max-width:100%">
                  <option :value="null"></option>
                  <option v-for="brand of brands" v-bind:key="brand.id" v-bind:value="brand.id">
                    {{ brand.name }}
                  </option>
                </select>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3">
                <label>Model</label>
              </b-col>
              <b-col sm="9">
                <select @change="handleSelectModel" class="form-control" v-model="device.installConfigurationModelId"
                        style="max-width:100%">
                  <option :value="null"></option>
                  <option v-for="model of models" v-bind:key="model.id" v-bind:value="model.id">
                    {{ model.name }}
                  </option>
                </select>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col sm="3">
                <label>Note</label>
              </b-col>
              <b-col sm="9">
                <textarea class="form-control bg-soft-warning" rows="6" v-model="device.note"></textarea>
              </b-col>
            </b-row>
          </form>
          <template v-slot:modal-footer>
            <b-button variant="light" @click="show = false">Close</b-button>
            <b-button variant="primary" @click="update()">Save Changes</b-button>
          </template>
        </b-modal>
      </div>

      <!-- Plan Selection Modal -->
      <div>
        <b-modal 
          v-model="showPlanSelection" 
          title="Choose Plan for Activation" 
          title-class="font-18"
          size="lg"
          hide-footer
          centered
        >
          <div class="container-fluid">
            <div class="row mb-3">
              <div class="col-12">
                <p class="text-muted mb-3">
                  <i class="uil uil-info-circle mr-1"></i>
                  Select the type of plan you want to activate for this device. 
                  This action will start billing and cannot be reverted.
                </p>
              </div>
            </div>

            <div class="row">
              <!-- Standard Plan -->
              <div class="col-md-4 mb-3">
                <div 
                  class="card plan-card h-100" 
                  :class="{ 'selected': selectedPlanType === 'standard' }"
                  @click="selectPlan('standard')"
                  style="cursor: pointer; transition: all 0.3s ease;"
                >
                  <div class="card-body text-center">
                    <div class="plan-icon mb-3">
                      <i class="uil uil-star" style="font-size: 3rem; color: #5369f8;"></i>
                    </div>
                    <h5 class="card-title font-weight-bold mb-3">Standard Plan</h5>
                    <div v-if="selectedPlanType === 'standard'" class="mt-3">
                      <span class="badge badge-success badge-pill">
                        <i class="uil uil-check mr-1"></i>Selected
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Test Plan -->
              <div class="col-md-4 mb-3">
                <div 
                  class="card plan-card h-100" 
                  :class="{ 'selected': selectedPlanType === 'test' }"
                  @click="selectPlan('test')"
                  style="cursor: pointer; transition: all 0.3s ease;"
                >
                  <div class="card-body text-center">
                    <div class="plan-icon mb-3">
                      <i class="uil uil-flask" style="font-size: 3rem; color: #f7b84b;"></i>
                    </div>
                    <h5 class="card-title font-weight-bold mb-3">Test Plan</h5>
                    <div v-if="selectedPlanType === 'test'" class="mt-3">
                      <span class="badge badge-success badge-pill">
                        <i class="uil uil-check mr-1"></i>Selected
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Safe Link Plan -->
              <div class="col-md-4 mb-3">
                <div 
                  class="card plan-card h-100" 
                  :class="{ 'selected': selectedPlanType === 'safelink' }"
                  @click="selectPlan('safelink')"
                  style="cursor: pointer; transition: all 0.3s ease;"
                >
                  <div class="card-body text-center">
                    <div class="plan-icon mb-3">
                      <i class="uil uil-shield-check" style="font-size: 3rem; color: #0acf97;"></i>
                    </div>
                    <h5 class="card-title font-weight-bold mb-3">Safe Link Plan</h5>
                    <div v-if="selectedPlanType === 'safelink'" class="mt-3">
                      <span class="badge badge-success badge-pill">
                        <i class="uil uil-check mr-1"></i>Selected
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Footer with buttons -->
            <div class="row mt-4">
              <div class="col-12">
                <div class="d-flex justify-content-end">
                  <b-button 
                    variant="light" 
                    @click="showPlanSelection = false; selectedPlanType = null"
                    :disabled="activatingPlan"
                    class="mr-2"
                  >
                    <i class="uil uil-times mr-1"></i>Cancel
                  </b-button>
                  <b-button 
                    variant="primary" 
                    @click="openConfirmationModal"
                    :disabled="!selectedPlanType || activatingPlan"
                  >
                    <i class="uil uil-arrow-right mr-1"></i>Continue
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </b-modal>
      </div>

      <!-- Plan Confirmation Modal -->
      <div>
        <b-modal 
          v-model="showPlanConfirmation" 
          title="Confirm Plan Activation" 
          title-class="font-18"
          centered
        >
          <div class="text-center py-3">
            <div class="mb-4">
              <i class="uil uil-exclamation-triangle text-warning" style="font-size: 4rem;"></i>
            </div>
            <h5 class="mb-3">Are you sure you want to activate the <strong>{{ getPlanName(selectedPlanType) }}</strong>?</h5>
            <p class="text-muted mb-0">
              This action will start billing and cannot be reverted.
            </p>
          </div>
          
          <template v-slot:modal-footer>
            <b-button 
              variant="light" 
              @click="showPlanConfirmation = false"
              :disabled="activatingPlan"
            >
              <i class="uil uil-times mr-1"></i>Cancel
            </b-button>
            <b-button 
              variant="danger" 
              @click="confirmPlanActivation"
              :disabled="activatingPlan"
            >
              <span v-if="activatingPlan">
                <b-spinner small class="mr-2"></b-spinner>
                Activating...
              </span>
              <span v-else>
                <i class="uil uil-check mr-1"></i>Yes, Activate Plan
              </span>
            </b-button>
          </template>
        </b-modal>
      </div>

      <div>
        <b-modal v-model="confirmation" title="Activate device plan" title-class="font-18">
          <form class="form-horizontal">
            <p>Are you sure to activate the device plan? The billing will be started. This action could not be
              reverted.</p>
          </form>
          <template v-slot:modal-footer>
            <b-button variant="light" @click="confirmation = false">Close</b-button>
            <b-button variant="primary" @click="activateDevicePlan()">Activate</b-button>
          </template>
        </b-modal>
      </div>

    </b-overlay>
  </Layout>
</template>

<style scoped>
.plan-card {
  border: 2px solid #e3e6f0;
  transition: all 0.3s ease;
  min-height: 200px;
}

.plan-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border-color: #5369f8;
}

.plan-card.selected {
  border-color: #5369f8;
  background-color: #f8f9fc;
  box-shadow: 0 0.5rem 1rem rgba(83, 105, 248, 0.2);
}

.plan-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
}

.plan-card .card-body {
  padding: 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.plan-card .card-title {
  color: #2c3e50;
  font-size: 1.25rem;
}

/* Responsividade */
@media (max-width: 768px) {
  .plan-card {
    margin-bottom: 1rem;
    min-height: 180px;
  }
}
</style>
